import { PrinterIcon } from "@heroicons/react/24/outline";
import React from "react";
import { parsePhone } from "util/phone";
import {
    ContactValueLabel,
    ContactValueRow,
    contactValueTextClasses,
} from "./display-row";

interface FaxDisplayProps {
    value: string;
}

export const FaxDisplay: React.FC<FaxDisplayProps> = props => {
    const { value } = props;

    if (!value) {
        return null;
    }

    return (
        <ContactValueRow Icon={PrinterIcon}>
            <span className={contactValueTextClasses}>{parsePhone(value).display}</span>
            <ContactValueLabel label="fax" />
        </ContactValueRow>
    );
};
